export default "__VITE_ASSET__CiWWc8x5__"